export const customCalendarQueryKeys = {
  all: ["custom-calendar"] as const,
  get: (id: string) => [...customCalendarQueryKeys.all, id] as const,
};

export const organiserCalendarTemplatesQueryKeys = {
  all: ["organiser-calendar-templates"] as const,
};
